import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { InvoiceConfigStore, InvoiceConfigDTO } from '../types';

const initialState = {
    config: null as InvoiceConfigDTO | null,
    isLoading: false,
    isSubmitting: false,
    error: null as string | null
};

export const useInvoiceConfigStore = create<InvoiceConfigStore>()(
    devtools(
        (set) => ({
            ...initialState,
            setConfig: (config) => set({ config }),
            setLoading: (loading) => set({ isLoading: loading }),
            setSubmitting: (submitting) => set({ isSubmitting: submitting }),
            setError: (error) => set({ error }),
            reset: () => set(initialState)
        }),
        { name: 'invoice-config-store' }
    )
);
